"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HealthResponse", {
    enumerable: true,
    get: function() {
        return HealthResponse;
    }
});
const _zod = require("zod");
const HealthResponse = _zod.z.object({
    healthy: _zod.z.boolean(),
    gitHash: _zod.z.string(),
    gitHashShort: _zod.z.string(),
    gitBranch: _zod.z.string(),
    environment: _zod.z.string()
});
